import { getCurrencyStr } from '../getCurrencyStr';
import { getDurationRangeStr } from '@amzn/atoz-shiftapp-utilities';
export var formatBreakdownDetailStr = function (hourlyCompensation, durationRange) {
    var rate = getCurrencyStr(hourlyCompensation, {
        forceRationalFormatting: true
    });
    var durationStr = getDurationRangeStr(durationRange);
    if (rate === null) {
        return null;
    }
    return "(".concat(rate, " x ").concat(durationStr, ")");
};
